let siteKey = '';
let loadedSiteKey = '';

let loaderPromise = null;

function resolveSiteKey() {
  if (siteKey) {
    return siteKey;
  }

  if (typeof window !== 'undefined') {
    const windowKey = window.RECAPTCHA_SITE_KEY || window.__RECAPTCHA_SITE_KEY__;
    if (windowKey) {
      siteKey = windowKey;
      return siteKey;
    }

    const meta = typeof document !== 'undefined'
      ? document.querySelector('meta[name="recaptcha-site-key"]')
      : null;
    if (meta?.content) {
      siteKey = meta.content;
      return siteKey;
    }
  }

  return '';
}

function loadRecaptchaScript() {
  const currentSiteKey = resolveSiteKey();

  if (!currentSiteKey) {
    return Promise.reject(new Error('Missing reCAPTCHA site key configuration'));
  }

  if (loaderPromise && loadedSiteKey === currentSiteKey) {
    return loaderPromise;
  }

  if (loaderPromise && loadedSiteKey !== currentSiteKey) {
    loaderPromise = null;
  }

  const existingScript = document.querySelector('script[data-recaptcha-enterprise]');
  const existingScriptKey = existingScript?.getAttribute('data-recaptcha-site-key') || '';

  if (existingScript && existingScriptKey !== currentSiteKey) {
    existingScript.remove();
  }

  if (window.grecaptcha?.enterprise && loadedSiteKey === currentSiteKey) {
    loaderPromise = new Promise((resolve) => {
      window.grecaptcha.enterprise.ready(() => resolve(window.grecaptcha.enterprise));
    });
    return loaderPromise;
  }

  loaderPromise = new Promise((resolve, reject) => {
    const scriptInDom = document.querySelector('script[data-recaptcha-enterprise]');

    const handleLoaded = () => {
      if (window.grecaptcha?.enterprise) {
        loadedSiteKey = currentSiteKey;
        window.grecaptcha.enterprise.ready(() => resolve(window.grecaptcha.enterprise));
      } else {
        reject(new Error('reCAPTCHA Enterprise did not initialize correctly'));
      }
    };

    const handleError = () => reject(new Error('Unable to load reCAPTCHA script'));

    if (scriptInDom) {
      scriptInDom.addEventListener('load', handleLoaded, { once: true });
      scriptInDom.addEventListener('error', handleError, { once: true });
      return;
    }

    const script = document.createElement('script');
    script.src = `https://www.google.com/recaptcha/enterprise.js?render=${currentSiteKey}`;
    script.async = true;
    script.defer = true;
    script.setAttribute('data-recaptcha-enterprise', 'true');
    script.setAttribute('data-recaptcha-site-key', currentSiteKey);
    script.onload = handleLoaded;
    script.onerror = handleError;
    document.body.appendChild(script);
  });

  return loaderPromise;
}

export function setRecaptchaSiteKey(value) {
  if (value) {
    siteKey = value;
  }
}


export function isRecaptchaConfigured() {
  return Boolean(resolveSiteKey());
}

export async function ensureRecaptcha() {
  const grecaptchaEnterprise = await loadRecaptchaScript();
  return grecaptchaEnterprise;
}

export async function executeRecaptcha(action) {
  const currentSiteKey = resolveSiteKey();
  if (!currentSiteKey) {
    throw new Error('Missing reCAPTCHA site key');
  }
  const grecaptchaEnterprise = await ensureRecaptcha();
  return grecaptchaEnterprise.execute(currentSiteKey, { action });
}

export function getRecaptchaSiteKey() {
  return resolveSiteKey();
}
